var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-table", {
    attrs: {
      fields: _vm.fields,
      items: _vm.items,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "table-class": "text-nowrap",
      responsive: "",
      hover: "",
    },
    on: {
      "row-clicked": _vm.onClickRow,
      "update:sortBy": function ($event) {
        _vm.sortBy = $event
      },
      "update:sort-by": function ($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function ($event) {
        _vm.sortDesc = $event
      },
      "update:sort-desc": function ($event) {
        _vm.sortDesc = $event
      },
      "sort-changed": _vm.onSortChanged,
    },
    scopedSlots: _vm._u([
      {
        key: "cell(name)",
        fn: function (data) {
          return [
            _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(data.item.name))]),
          ]
        },
      },
      {
        key: "cell(status)",
        fn: function (data) {
          return [
            _c("admin-company-status-badge", {
              attrs: { company: data.item.company },
            }),
          ]
        },
      },
      {
        key: "cell(plan_start)",
        fn: function (data) {
          return [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.convertFromUtc(data.item.company.pivot.starts_at, "L")
                ) +
                "\n  "
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }